var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-container",
      class: { "required-fail": _vm.requiredFail }
    },
    [
      _vm.disabled && _vm.value
        ? _c(
            "a",
            {
              staticClass: "accent--text",
              staticStyle: { "background-color": "white" },
              attrs: { href: _vm.getValidURL(_vm.value), target: "_blank" }
            },
            [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")]
          )
        : _c("input", {
            attrs: {
              type: "text",
              disabled: _vm.disabled,
              placeholder: _vm.placeholder
            },
            domProps: { value: _vm.value },
            on: {
              input: function($event) {
                return _vm.updateValue($event.target.value)
              }
            }
          })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10612faf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10612faf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_Atoms/InputTypes/InputTypeUrl.vue
// module id = null
// module chunks = 